
import React from 'react';
import Echo from 'laravel-echo';
import { graphqlFindResults } from '../graphql-helpers';
import PusherJs from 'pusher-js';
//import Config from '../config';
import * as graphqlFragments from '../graphql/fragments.graphql';
import { useCallback, useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import isEqual from 'react-fast-compare';
import { useUserContext} from './user-context';
import {Button} from "@mui/material";
import {Refresh} from "@mui/icons-material";
import { useToast } from "./toast";
import {progressToast} from "../utils/progress-toast";
import {useDaybookContext} from "./Daybook/DayBookContext";
export const WebSocketContext = React.createContext(null);

// Bearer cookie is used for actual authentication
export const WebSocketProvider = (props: { children: any }) => {
    const [watched, setWatched] = useState({ campaigns: [], panelBookings: [] });
    const [activeChannels,setActiveChannels] = useState([]);
    const [echo, setEcho] = useState(null);
    const apolloClient = useApolloClient();
    const { toast} = useToast();
    const daybook = useDaybookContext();
    const user = useUserContext();
    console.log('daybook is',daybook);
//    console.log('init connection',indexedFrags);
    useEffect(() => {
        console.log('user cookie is',user?.cookie);
        if(!user?.cookie) return;
        if(!daybook) return;
        // key/SECRET are required for the pusher API.
        const key = daybook?.pusherConfig?.key??'';
        const refreshAction = <Button className="always-show" variant="contained" onClick={()=>{ document.location.reload()} }><Refresh/>Reload now</Button>;
        const t = progressToast(toast)('WEBSOCKET');
        t.start('Connecting to WS server');
        const Pusher = new PusherJs(daybook?.pusherConfig?.key??'',
            {
                wsPort:daybook?.pusherConfig?.wsPort,
                wssPort:daybook?.pusherConfig?.wssPort,
                wsHost:daybook?.pusherConfig?.wsHost,
                forceTLS:!!daybook?.pusherConfig?.forceTLS,
                enabledTransports: ['ws','wss'],
                disabledTransports: ['xhr_streaming']
            });
//            Config.pusherConfig);
        console.log('ERROR1A conncted as',Pusher.connection.state);
        Pusher.connection.bind('error',function(e) {
            t.fail(<span>WS server error.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        Pusher.connection.bind('failed',function(e) {
            t.fail(<span>WS server error.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        const cookie = user.cookie;
        const echoTemp = new Echo({
            broadcaster: 'pusher',
            key: key,
            secret: daybook?.pusherConfig?.secret,
            auth: {headers: {Authorization: "Bearer " +cookie,
            Accept:'application/json'}},
            client: Pusher,
            enabledTransports: ['ws','wss'],
            disabledTransports: ['xhr_streaming'],
            wsPort: daybook.pusherConfig.wssPort ? daybook.pusherConfig.wssPort : daybook.pusherConfig.wsPort,
            wsHost: daybook.pusherConfig.wsHost,
            host: daybook.pusherConfig.wsHost,
            port: daybook.pusherConfig.wssPort ? daybook.pusherConfig.wssPort : daybook.pusherConfig.wsPort
        });
        // seems to be a undocumented feature, endpoint needs forcibly setting
        echoTemp.connector.pusher.config.authEndpoint = daybook.baseUrl+'broadcasting/auth';
        echoTemp.connector.pusher.config.auth = {};
        echoTemp.connector.pusher.config.auth.headers = {};
        echoTemp.connector.pusher.config.auth.headers['Authorization'] = 'Bearer '+cookie;
        echoTemp.connector.pusher.config.auth.headers['Accept'] = 'application/json';
        echoTemp.connector.pusher.connection.bind('error',function() {
            //t.fail(<span>WS server error.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        echoTemp.connector.pusher.connection.bind('disconnected',function() {
            //t.fail(<span>WS server authorization error.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        echoTemp.connector.pusher.connection.bind('unavailable',function() {
            t.fail(<span>WS server unavailable.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        echoTemp.connector.pusher.connection.bind('connected',function() {
            t.ok('WS server: successful connection');
        });
        echoTemp.connector.pusher.connection.bind('failed',function() {
            t.fail(<span>WS server connection failed.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        echoTemp.private('static-data').listen('.DataUpdate', (e) => {
            console.log('[WSP]', 'message', e, e.data, e.data);

            // if it's an object, this doesn't work o_O.
            const data = graphqlFindResults(e.data);
            if (!data || !data.length) return;
            data.forEach((row) => {
                /*console.log('[WSP]', 'fragment', cachedRow,graphqlFragments,graphqlFragments[row.__typename + 'Full']);
                var cachedRow = apolloClient.readFragment({
                    id:row.__typename+':'+row.id,
                    fragment:graphqlFragments[row.__typename + 'Full'],
                    fragmentName: row.__typename + 'Full'
                });
                console.log('[WSP]', 'read', row.__typename + 'Full', cachedRow,graphqlFragments[row.__typename + 'Full']);*/
                console.log('[WSP]', 'write', row.__typename + 'Full', row);
                //if(data.length) return;
                apolloClient.writeFragment({
                    id: row.__typename + ':' + row.id,
                    fragment: graphqlFragments[row.__typename + 'Full'],
                    //      fragmentName:,
                    data: row,
                    fragmentName: row.__typename + 'Full'
                });
                /*cachedRow = apolloClient.readFragment({
                    id:row.__typename+':'+row.id,
                    fragment:graphqlFragments[row.__typename + 'Full'],
                    fragmentName: row.__typename + 'Full'
                });
                console.log('[WSP]', 'read', row.__typename + 'Full', cachedRow,graphqlFragments[row.__typename + 'Full']);*/
            });
        }).error(function() {
            t.fail(<span>WS server authorization failed for channels.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        echoTemp.private('users.'+(user?.user?.id??0)).listen('.UserNotification', (e) => {
            if(e) {
                const notification = e.data?e.data:e;
                console.log('UserNotification',notification);
                user.setUserNotifications([notification]);
            }
        }).listen('.ChallengeWatchCounts', (e) => {
            console.log('ChallengeWatch',e.data);
            if(e && e.data) {
                user.setActiveChallengeCounts(e.data);
            }
        }).error(function() {
            t.fail(<span>WS user authorization failed for user channel.<br/>Updates may not appear, please reload</span>,{action:refreshAction});
        });
        echoTemp.channel('js-version').listen('.JsVersionUpdated', (e) => {
            console.log('JsVersionUpdated', e);
            if(e && e.version) {
                user.notifyJsVersion(e.version);
            }
        });
        setEcho(echoTemp);
    },[user?.cookie,user?.user?.id,apolloClient,daybook]);
    useEffect(()=>{
        if(!echo) return;
        let hasChanged = false;
        activeChannels.forEach((channel) => {
            const parts = channel.split('.',2);
            if(parts.length>1) {
                if (watched[parts[0]].indexOf(parseInt(parts[1])) ==-1) {
                    hasChanged = true;
                    console.log('[WSP] unsubscribe',channel,parts[0],parts[1],watched[parts[0]]);
                    echo.leave(channel);
                }
            }
        });
        Object.entries(watched).forEach(([name,subchannels])=>{
            subchannels.forEach((subchannel)=>{
                if(activeChannels.indexOf(name+'.'+subchannel)>-1) return;
                hasChanged = true;
                echo.private(name + '.' + subchannel).listen('.RawData',function({data}) {
                    if(!data) return;
                });

                echo.private(name + '.' + subchannel).listen('.DataUpdate',function({data}) {
                    if (!data) return;
                    if(data && !Array.isArray(data)) {
                        data = [data];
                    }
                    data.forEach((row) => {
                        console.log('[WSP]', 'fragment', graphqlFragments,graphqlFragments[row.__typename + 'Full']);
                        const cachedRow = apolloClient.readFragment({
                            id:row.__typename+':'+row.id,
                            fragment:graphqlFragments[row.__typename + 'Full'],
                            fragmentName: row.__typename + 'Full'
                        });
                        console.log('[WSP]', 'cached', cachedRow,row);
                        //                            console.log('[WSP]', 'read', row.__typename + 'Full', cachedRow,graphqlFragments[row.__typename + 'Full']);
                        if(!cachedRow) return;
                        //if(data.length) return;
                        console.log('[WSP]', 'write', row.__typename + 'Full', row);
                        apolloClient.writeFragment({
                            id: row.__typename + ':' + row.id,
                            fragment:graphqlFragments[row.__typename + 'Full'],
                            fragmentName: row.__typename + 'Full',
                            data: row
                        });
                    });
                });
            })
            console.log('[WSP] check',name,subchannels);
        });
        if(hasChanged) {
            const newActive = [];
            Object.entries(watched).forEach(([name,subchannels])=>{
                subchannels.forEach((subchannel)=>{
                    newActive.push(name+'.'+subchannel);
                });
            });
            setActiveChannels(newActive);
        }
    },[activeChannels,watched,echo]);
    const setWatches = useCallback((name, values) => {
        console.log('[WSP]', 'Set Watches to', name, values, echo,setEcho);
        setWatched((oldValues: any) => {
            console.log('[WSP]', 'old', oldValues, 'values', values);
            if (isEqual(oldValues[name], values)) {
                return oldValues;
            }
            const retValues = {...oldValues};
            retValues[name] = values;
            return retValues;
        });
    }, [echo,setWatched,apolloClient]);
    return (<WebSocketContext.Provider
        value={{
            setWatches: setWatches,
            watched: watched,
        }}
    >
        {props.children}
    </WebSocketContext.Provider>
    );
};

